import { createStore, applyMiddleware, compose } from "redux"
import createDebounce from "redux-debounced"
import thunk from "redux-thunk"
import rootReducer from "../reducers/rootReducer"
/* import { messaging } from "firebase"
import { firebaseConfig } from "../../authServices/firebaseConfig" */

const middlewares = [thunk, createDebounce()]
/* 
const firebaseApp = firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging(); */

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
  rootReducer,
  { auth: { login: { user: (localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')) : ""), token: (localStorage.getItem('token') !== null ? localStorage.getItem('token') : "")} } },
  composeEnhancers(applyMiddleware(...middlewares))
)
/* 
messaging.onMessage((payload) => {
  console.log('Received Firebase message:', payload);
  store.dispatch({ type: 'SHOW_EVENTS', payload: payload.events });
}); */

export { store }
